import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <footer className="bg-ink-950" data-id="element-15" data-mp="3ucndvrnypfti">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-16" data-mp="3udf8az5tp7i7">
        <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-17" data-mp="c7aew89tyci4">
          Fuerte en el espejo.
          <span className="block text-flame-500" data-id="element-18" data-mp="83m7pqp41ixe">Imparable en la calle.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-zinc-400" data-id="element-19" data-mp="m3ngdsbm9unf">
          12 semanas para dejar de elegir entre las pesas y el running. Empezá hoy con el
          70% de descuento y los 5 bonos incluidos.
        </p>
        <div className="mt-9" data-id="element-20" data-mp="vwks9fm3sld2">
          <CTAButton data-id="element-21" data-mp="qv5apxj4wwzf" />
        </div>
        <p className="mt-4 text-sm text-zinc-500" data-id="element-22" data-mp="qw6uqri4otta">
          Pago único de $17.990 ARS · Garantía de 7 días · Acceso de por vida
        </p>

        <p className="mt-12 border-t border-ink-800 pt-8 text-xs text-zinc-600" data-id="element-23" data-mp="zwd2dwr5azkj">
          © {new Date().getFullYear()} Método Híbrido 2.0. Este programa es educativo y no
          reemplaza el consejo médico profesional.
        </p>
      </div>
    </footer>;
}